import React from 'react'
import { useHistory } from 'react-router-dom'
import { Button, Form, Tooltip, OverlayTrigger } from 'react-bootstrap'
import { useStateValue } from '@State'
import { WizardSteps } from '../../components'
import { linkPaths, COURSENUM } from '../urls'
import { BadgeName } from './BadgeName'
import { IncompleteBadgeImage } from './IncompleteBadgeImage'
import { CompleteBadgeImage } from './CompleteBadgeImage'

export function Design() {
  const [state, dispatch] = useStateValue()
  const history = useHistory()

  const goBack = e => {
    e.preventDefault()
    window.location = `/instructor/achievements/${COURSENUM}/`
  }

  const goNext = e => {
    e.preventDefault()
    history.push(linkPaths.requirements)
  }

  const handleChange = change => {
    dispatch({ type: 'UPDATE_BADGE_INFO', badgeInfo: { description: change } })
  }

  const needsRequirements = state.badgeInfo.name.length === 0

  const imageTooltip = (
    <Tooltip id="image_tooltip">
      Icon will be cropped to 100x100
      <br />
      Icon can be 1 MB or less
    </Tooltip>
  )

  return (
    <div>
      <WizardSteps
        edit={state.badgeInfo.retrievedEditData}
        step={1}
        linkPaths={linkPaths}
        heading="Badge"
        subHeading="Build Badge"
        annotation="Click an item to edit the content"
      />
      <div id="badge_box">
        <div className="text-center" id="badge_name">
          <BadgeName />
        </div>
        <div id="images">
          <div className="image" id="incompleteImage">
            <OverlayTrigger placement="right" overlay={imageTooltip}>
              <span>Incomplete Icon</span>
            </OverlayTrigger>
            <IncompleteBadgeImage />
          </div>
          <div className="image" id="completeImage">
            <OverlayTrigger placement="right" overlay={imageTooltip}>
              <span>Complete Icon</span>
            </OverlayTrigger>
            <CompleteBadgeImage />
          </div>
        </div>
        <div style={{ marginLeft: '5%', marginRight: '5%' }}>
          <Form.Group controlId="descriptionID">
            <Form.Label>Description</Form.Label>
            <Form.Control
              as="textarea"
              onChange={e => handleChange(e.target.value)}
              value={state.badgeInfo.description}
            />
          </Form.Group>
        </div>
      </div>
      <div className="btn_container">
        <Button variant="primary" onClick={goBack}>
          Back
        </Button>
        <Button variant="primary" disabled={needsRequirements} onClick={goNext}>
          Next
        </Button>
      </div>
    </div>
  )
}
